<template>
  <nav class="bg_red navbar navbar-expand-md navbar-light d-none d-md-block ">
    <div id="nav" class="container">
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto">
          <li v-for="item in navs" :key="item.id" :class="'nav-item '+(item.children?'has-children':'')"
              @mouseenter="handleHoverIn(item)"
              @mouseleave="handleHoverOut(item)">
            <a v-if="item.name==='首页'" href="/" :class="'text_white nav-link '+item.active">{{ item.name }}</a>
            <a v-else :href="'/nav/list/'+item.id" :class="'text_white nav-link '+item.active">{{ item.name }}</a>
            <ul v-if="item.children" :class="'dropdown-menu '+item.childActive">
              <li v-for="citem in item.children" :key="citem.id">
                <a :href="'/nav/list/'+citem.id">{{ citem.name }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import {getNavs} from "@/api/home"
import {handleNavData} from "@/utils"

export default {
  data() {
    return {
      navs: {}
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      const temp ={_sort:'sort:ASC'}
      getNavs(temp).then((response) => {
        this.navs = handleNavData(response)
      })
    },
    handleHoverIn(item) {
      // item['active'] = 'current'
      item['active'] = 'active'
      item['childActive'] = 'jk1 on'
    },
    handleHoverOut(item) {
      item['active'] = ''
      item['childActive'] = 'jk1'
    }
  }
}
</script>
<style  scoped>
.bg_red{
  background:#E21B1B ;
}
.text_white{
  color: white !important;
}
.text_white.active{
  color:black !important;
}
</style>
